"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Label = function Label(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "blue" : _ref$color;
  var translations = {
    checkOffer: (0, _langLibrary["default"])("Check out this great deal")
  };
  var styles = {
    height: 40,
    px: 15,
    font: "xs_caps",
    color: "white",
    bg: color,
    display: "inline-flex",
    alignItems: "center"
  };
  if (color === "blue") {
    styles = _objectSpread(_objectSpread({}, styles), {}, {
      bg: "blue",
      borderWidth: "1px",
      borderColor: "white",
      borderStyle: "solid"
    });
  }
  if (color === "red") {
    styles = _objectSpread(_objectSpread({}, styles), {}, {
      bg: "christmasLightRed"
    });
  }
  return __jsx(_Box["default"], {
    sx: styles
  }, translations.checkOffer);
};
var _default = Label;
exports["default"] = _default;